/***
*
*   ACCOUNTS
*   Manage all accounts signed up to your application
*
**********/

import { useContext, useState, useEffect } from 'react';
import { AuthContext, ViewContext, Card, Table, Animate, usePlans, useAPI, useUserEmails } from 'components/lib';

export function Accounts(props) {
  const [account, setAccount] = useState([]);

  const viewContext = useContext(ViewContext);
  const authContext = useContext(AuthContext);

  const plans = usePlans();
  const accounts = useAPI('/api/account');
  const userEmails = useUserEmails();
  const [userAccounts, setUserAccounts] = useState([]);

  useEffect(() => {
    if (userEmails?.data) {
      setUserAccounts(userEmails.data)
    }
  }, [userEmails?.data]);


  function editAccount(data, callback) {
    viewContext.modal.show({

      title: 'Edit Account',
      form: {
        id: {
          type: 'hidden',
          value: data.id
        },
        plan: {
          label: 'Plan',
          type: 'select',
          options: plans.data.list,
          default: data.plan,
          required: true,
        },
        active: {
          label: 'Status',
          type: 'select',
          default: data.active,
          options: [
            { value: 1, label: 'Active' },
            { value: 0, label: 'Cancelled' }
          ],
          required: true
        },
      },
      buttonText: 'Save',
      url: `${authContext.remote_server}/api/account/plan`,
      method: 'PATCH'

    }, (res) => {

      viewContext.notification.show(data.name + ' was updated', 'success', true);
      callback(res);

    });
  }

  function deleteAccount(data, callback) {
    viewContext.modal.show({
      title: 'Delete Account',
      form: {},
      buttonText: 'Delete Account',
      text: `Are you sure you want to close ${data.email}'s account?`,
      url: `${authContext.remote_server}/api/account/${data.id}`,
      method: 'DELETE',
      destructive: true,
    }, () => {

      viewContext.notification.show(`${data.email} was deleted`, 'success', true);
      callback();

    });
  }

  useEffect(() => {
    // format the user list
    let list = [];

    if (accounts?.data?.length) {
      list = accounts?.data.map(x => {
        return {

          id: x.id,
          name: x.name,
          owner_email: x.owner_email,
          plan: x.plan,
          date_created: x.date_created,
          owner_name: x.owner_name,
          active: x.active ? "Yes" : "No"

        }
      })
    }
    setAccount(list);

  }, [accounts]);

  return (
    <Animate>
      <Card loading={false}>

        <Table
          search
          show={['name', 'plan', 'date_created', 'owner_email', 'owner_name', 'active']}
          data={account}
          loading={accounts?.loading}
          badge={{ col: 'plan', color: 'blue' }}
          actions={{
            edit: editAccount,
            delete: deleteAccount,
            email: true
          }}

          searchableDropdownData={
            [
              {
                label: 'Email',
                name: 'email',
                placeholder: ' user email',
                options: userAccounts?.accounts
              },
            ]
          }
        />

      </Card>
    </Animate>
  );
}
